import OrbLoading from "./orb-loading";

export default OrbLoading